import { jsonToStorage } from '../utils/utils';

import {listChanges} from '../models/changes';
import {listAssessments} from '../models/assessments';
import {listFinalEvaluations} from '../models/finalevaluation';
import {listAnimals} from '../models/animals';
import {getFacility} from '../models/facility';
import {listUsers} from '../models/users';
import {listSectionAs} from '../models/sectiona';
import {listSectionBs} from '../models/sectionb';
import {listSectionCs} from '../models/sectionc';
import {listSectionCIoAs} from '../models/sectioncioa';
import {listBehaviorTagSets} from '../models/behaviorTags';

import { today } from '../utils/datetime';


/*
user -> current logged in user
*/
const uploadLocalStorage = async ({user}) => {
    try{
        let animals = await listAnimals();
        let users = await listUsers();
        let assessments = await listAssessments();
        let finalEvaluations = await listFinalEvaluations();
        let changes = await listChanges();
        let facility = await getFacility();
        let sectionA = await listSectionAs();
        let sectionB = await listSectionBs();
        let sectionC = await listSectionCs();
        let sectionCIoA = await listSectionCIoAs();
        let behaviorTagSets = await listBehaviorTagSets();
        let currentUserName = users.find((cur) => cur.id === user?.id)?.name

        let data = {
            date: today(),
            animals,
            users,
            assessments,
            finalEvaluations,
            changes,
            facility,
            sectionA,
            sectionB,
            sectionC,
            sectionCIoA,
            behaviorTagSets
        };

        let jsonString=JSON.stringify(data);
        const results = await jsonToStorage(`${facility.name}/${currentUserName}/${today().format('YYYY/MM/DD/YYYYMMDD-HHmmss')}.json`,jsonString);
        return results;
    }
    catch(e){
        console.error(e);
        throw e;
    }
};

export {uploadLocalStorage};
